import React from 'react';
import styles from '@dazn/lp-web/src/components/VideoBanner/video-banner.module.css';
import VideoModal from '@dazn/lp-web/src/components/VideoBanner/VideoModal';
import {IVideo} from '../../types';

interface VideoBannerProps {
    url: IVideo;
    title: string;
}

const VideoBanner: React.FC<VideoBannerProps> = ({url, title = ''}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.playButton}>
                <VideoModal title={title} url={url} />
            </div>
        </div>
    );
};

export default VideoBanner;
